import { useEffect, useRef, useState } from 'react';

/**
 * Dashboard row: full-width table, optional side rail on xl+ only (avoids overlapping
 * wide tables). Rail max-height tracks the table block when side-by-side.
 */
export function DashboardTableRailLayout({ table, rail }) {
  const tableRef = useRef(null);
  const [railMaxHeight, setRailMaxHeight] = useState(null);

  useEffect(() => {
    const node = tableRef.current;
    if (!node) return undefined;

    const sync = () => {
      const wide =
        typeof window.matchMedia === 'function' &&
        window.matchMedia('(min-width: 1280px)').matches;
      if (!wide) {
        setRailMaxHeight(null);
        return;
      }
      setRailMaxHeight(node.offsetHeight > 0 ? node.offsetHeight : null);
    };

    sync();
    if (typeof ResizeObserver === 'undefined') {
      window.addEventListener('resize', sync);
      return () => window.removeEventListener('resize', sync);
    }
    const observer = new ResizeObserver(sync);
    observer.observe(node);
    window.addEventListener('resize', sync);

    return () => {
      observer.disconnect();
      window.removeEventListener('resize', sync);
    };
  }, [table]);

  return (
    <div className="flex flex-col gap-4 xl:grid xl:grid-cols-[minmax(0,1fr)_min(300px,32%)] xl:items-start">
      <div ref={tableRef} className="min-w-0 overflow-hidden">
        {table}
      </div>
      <div
        className="min-w-0 w-full shrink-0 xl:w-auto"
        style={railMaxHeight ? { maxHeight: `${railMaxHeight}px` } : undefined}
      >
        {typeof rail === 'function' ? rail({ maxHeight: railMaxHeight }) : rail}
      </div>
    </div>
  );
}
